module.exports = __webpack_public_path__ + "media/images/auth-hero-payments-d72b24a339a0165b2cd65638068d83ad.webp";